module.exports = "/_next/static/images/ReEngagementDesktop-c5b600cd8d0a168315e09e6f54d377e0.webp";